/** @jsxImportSource @emotion/react */
import { Box } from '@mui/material';
import { css } from '@emotion/react';
import withHeader from '../../HOC/WithHeader';
import SearchAndFilters from './components/search-and-filters';
import PayoutCommissionsListTable from './components/payout-commision-list-table';
import UploadInvoiceModal from './components/upload-invoice-modal';
import PaymentDetailsModal from './components/payment-details-modal';
import { PaymentStatus } from './typings';
import { selectedCommisionItemAtom } from './state';
import { useAtom } from 'jotai';

const PayoutCommissionsPage = () => {
  const [selectedCommissionItem, setSelectedCommissionItem] = useAtom(selectedCommisionItemAtom);
  return (
    <div>
      <Box
        css={css`
          padding: 20px 80px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 20px;
          flex: 1 0 0;
          align-self: stretch;
        `}
      >
        <SearchAndFilters />
        <PayoutCommissionsListTable />
        {/* <UploadInvoiceModal
          commissionId={selectedCommissionItem?.id}
          handleClose={() => setSelectedCommissionItem(null)}
          open={!!selectedCommissionItem && selectedCommissionItem.paymentStatus !== PaymentStatus.PAID}
        />
        <PaymentDetailsModal
          open={!!selectedCommissionItem && selectedCommissionItem.paymentStatus === PaymentStatus.PAID}
          handleClose={() => setSelectedCommissionItem(null)}
        /> */}
      </Box>
    </div>
  );
};

export default withHeader(PayoutCommissionsPage);
